import { Component, OnInit } from '@angular/core';
import { FeatureContent } from 'src/app/data-models/common/feature-content.model';
import { SnapshotService } from 'src/app/modules/snapshot/services/snapshot.service';
import { SnapshotStatus } from '../enums/snapshot.enum';
import { LoggerService } from 'src/app/services/logger/logger.service';

@Component({
	selector: 'vtr-page-snapshot',
	templateUrl: './page-snapshot.component.html',
	styleUrls: ['./page-snapshot.component.scss'],
})
export class PageSnapshotComponent implements OnInit {
	snapshotSupportCard: FeatureContent = new FeatureContent();

	constructor(private snapshotService: SnapshotService, private loggerService: LoggerService) {}

	ngOnInit(): void {
		this.initializeSnapshots();
	}

	private initializeSnapshots() {
		if (
			this.snapshotService.snapshotStatus === SnapshotStatus.snapshotCompleted ||
			this.snapshotService.snapshotStatus === SnapshotStatus.baselineCompleted
		) {
			// If a snapshot/baseline was finished while I'm not on snapshot page, I'll reset it to initial state
			this.snapshotService.snapshotStatus = SnapshotStatus.notStarted;
		} else if (this.snapshotService.snapshotStatus === SnapshotStatus.firstLoad) {
			// If it is the first time I'm on this page, initialize it with the first snapshot
			this.snapshotService.snapshotStatus = SnapshotStatus.fullSnapshotInProgress;

			const componentSnapshotPromises = [];

			this.snapshotService.getAllComponentsList().forEach((key) => {
				componentSnapshotPromises.push(this.snapshotService.getCurrentSnapshotInfo(key));
			});

			Promise.all(componentSnapshotPromises)
				.then(() => {
					this.loggerService.info('Success on all promises');
				})
				.catch((error) => {
					this.loggerService.error(`Failure requesting snapshot data: ${error}`);
				})
				.finally(() => {
					this.snapshotService.snapshotStatus = SnapshotStatus.snapshotCompleted;
				});
		}
	}
}
